import { useEffect, useMemo } from "react";
import { useMe } from "@/data/user.ts";
import { useSEO } from "@/contexts/SeoContext.tsx";
import { getGreeting } from "@/utils/get-greetings.ts";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import MobileView from "@/components/home/MobileView.tsx";
import PageHeading from "@/components/ui/PageHeading.tsx";
import DesktopView from "@/components/home/DesktopView.tsx";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

export default function Home() {
  const { me } = useMe();
  const breakpoint = useBreakpoint();
  const memoizedGreeting = useMemo(
    () => getGreeting(me?.item.user.first_name),
    [me],
  );
  const { setGlobalState } = useGlobals();
  const { setTitle, setDescription } = useSEO();

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background-light");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTitle(`${me?.item.user.first_name} ${me?.item.user.last_name} | Home`);
    setDescription("Home page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me]);

  return (
    <DashboardContentLayout className={"until-lg:px-0"}>
      <PageHeading
        title={memoizedGreeting}
        className="[&_h2]:text-white [&_p]:text-white z-[100] 3xl:container 3xl:mx-auto lg:!pb-0 relative lg:h-fit px-4"
        titleClassName="!text-white opacity-100 text-sm lg:!text-2xl"
      />

      {["xs", "sm", "md"].indexOf(breakpoint) !== -1 ? (
        <MobileView />
      ) : (
        <DesktopView />
      )}
    </DashboardContentLayout>
  );
}
